var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoltage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "#CE8D53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1489 9.64721C17.3437 9.25056 17.742 9 18.1777 9H21.8482C22.7033 9 23.2595 9.91594 22.8771 10.6944L20.8337 14.8541H21.7384C22.6863 14.8541 23.2273 15.9555 22.6586 16.7274L15.4399 26.5242C14.6569 27.5867 13.0158 26.7115 13.4284 25.4514L15.3652 19.5373H14.1518C13.2967 19.5373 12.7405 18.6214 13.1229 17.8429L17.1489 9.64721ZM18.5332 10.7562L15.0824 17.7811H16.1632C16.9483 17.7811 17.5027 18.564 17.2544 19.3221L16.186 22.5845L20.5881 16.6103H19.9031C19.048 16.6103 18.4919 15.6943 18.8743 14.9159L20.9176 10.7562H18.5332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoltage);
export default __webpack_public_path__ + "static/media/voltage.a51f146f.svg";
export { ForwardRef as ReactComponent };